import fotojr1 from '../../assets/fotoJr1b.jpg'
import './Folder.css'

function Folder(){
    return(
        <div className='folder-main'>
            
            <img className='folder-img' src={fotojr1} />  
            
            <div className='folder-text-main'>
                <h2 className='folder-text1'>Dr. Marcos Martins Soares Jr</h2>    
                <h2 className='folder-text2'>Hepatologista e Gastroenterologista</h2>    
                <h2 className='folder-text3'>Médico especialista em doenças do fígado e gastrointestinais</h2>  
            </div>
                         
        </div>
    )
}
export default Folder